export const CHART_COLOR = {
  BAR: { MYCOLOR: '#FFC001', OTHERCOLOR: '#BEBEBE' },
  SCATTER: { MYCOLOR: '#BEBEBE', OTHERCOLOR: '#FF612D' },
  LINE: { STROK_COLOR: '#BEBEBE ' },
}
